export const PredefinedSpaces = {
  TIDBITS_HUB: 'tidbitshub',
  DODAO_HOME: 'dodao-academy',
};

export enum Contexts {
  loginAndGoToSpaces = 'loginAndGoToSpaces',
  setupNewSpace = 'setupNewSpace',
  loginAndRedirectToHome = 'loginAndRedirectToHome',
  finishSetup = 'finishSetup',
}
